import { useState } from 'react';

import { Button } from 'libs/ui';
import { Input } from './input';
import { Label } from './label';
import { Select } from './select';
import { Control } from './control.styled';

export const QrControl = (props) => {
  const { onChange } = props;
  const [n1, setN1] = useState(5);
  const [n2, setN2] = useState(0);

  const insert = () => {
    const code = '%qrcode%,' + n1 + ',' + n2;
    onChange(code);
  };

  return (
    <Control>
      <Label>QR:</Label>
      <Input name="n1" placeholder="5" value={n1} onChange={setN1} width={'9.3ch'} asNumber />
      <Select name="n2" value={n2} onChange={setN2} width={'7.3ch'}>
        <option value="0">0</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
      </Select>
      {/* <Input name="n2" placeholder="0" value={n2} onChange={setN2} width={'8.6ch'} asNumber /> */}
      <Button size="small" $square onClick={insert}>
        &raquo;
      </Button>
    </Control>
  );
};
